import { Dialog } from '@mui/material';
import { WithGorillaInnerTheme } from './with-inner-theme';
var themeConfig = {
    key: 'dialog',
    config: {
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: function(param) {
                        var theme = param.theme;
                        return {
                            '&.MuiPickersPopper-paper': {
                                backgroundColor: theme.palette.common.white
                            }
                        };
                    }
                }
            }
        }
    }
};
export var GorillaDialog = WithGorillaInnerTheme(Dialog, themeConfig);
